import moment from 'moment-timezone';
import DatePicker from 'vue2-datepicker'
import custom from '@/custom';
import  codes from '@/codes';
import vSelect from 'vue-select';

//restful api
import { faq as board } from '@/service/api/board'

const default_opt = () => ({
  perPage: 15,
  currentPage: 1, totalRows: 0,
  sk: '', sv: '', skt: 'title', opt : { type : '' }, adv: false
});

const i18n_fields = {
  EN: [
    { key: 'id', label: '#.', sortable: false, thStyle: 'width: 10%' },
    { key: 'created_at', label: 'Date', sortable: true },
    { key: 'type', label: 'Solution', sortable: true },
    { key: 'title', label: 'Title', sortable: true },
  ],
  KO: [
    { key: 'id', label: '#.', sortable: false, thStyle: 'width: 10%' },
    { key: 'created_at', label: '날짜', sortable: true },
    { key: 'type', label: '솔루션', sortable: true },
    { key: 'title', label: '제목', sortable: true },
  ]
}

// props explain
// auto_refresh[default=false] : auth sync enable or disable, value is boolean
// user : this component to user list, using by user dependency

export default {
  name : "faqList",
  props: ['user', 'auto_refresh'],
  components: { DatePicker, vSelect },
  data: () => ({
    codes,
    color : ['info', 'danger', 'primary', 'secondary', 'warning', 'light'],
    custom,
    so : default_opt(),
    sync : { interval : 15, stop : false, th : undefined, enable : false },
    summaryData : [],
    type : '',
    hide_del : true,
  }),
  computed: {
    _summary() { return this.summaryData },
    startRow() { return this.so.totalRows - (this.so.currentPage - 1) * this.so.perPage; },
    fields() {
      return i18n_fields[this.i18n];
    }
  },
  methods: {
    search_opt() {
      this.so.adv = !this.so.adv;
      if(this.so.adv) {
        this.so.opt['created_at_ed'] = moment().add(1, "day").startOf('d');
        this.so.opt['match_type'] = 'and';
        this.so.opt['type'] = '';
        this.so.sv = '';
      } else { this.reset(); }
    },
    set_op(k, v) {
      if(v == 'false' || v == 'true') {
        return { name : k, value : v === "false" ? false : true, op : '=' }
      }
      return { name : k, value : `%${v}%`, op : 'like' }
    },
    set_sd(v, k = 'created_at') {
      let opt = this.so.opt;
      if(!v) { delete opt[`${k}_sd`]; delete opt[`${k}_ed`]; }
      else {
        let ed = opt[`${k}_ed`] || moment().startOf('d');
        let sd = opt[`${k}_sd`] || ed;
        switch(v) {
          case '-1d' : sd = moment(sd).subtract(1, 'd'); break;
          case '-1w' : sd = moment(sd).subtract(1, 'w'); break;
          case '-1m' : sd = moment(sd).subtract(1, 'M'); break;
          case 'w' : sd = moment(ed).startOf('isoweek'); break;
          case 'm' : sd = moment(ed).startOf('month'); break;
        }
        opt[`${k}_sd`] = sd.format('YYYY-MM-DD');
      }
      this.so.opt = Object.assign({}, this.so.opt, opt);
    },
    pause: function() {
      this.sync.stop = !this.sync.stop;
      if(this.sync.th) { clearTimeout(this.sync.th); this.sync.th = undefined; }
      if(!this.sync.th && this.sync.stop) { this.sync.th = setTimeout(this.refresh, 1000 * this.sync.interval ); }
    },
    refresh() {
      console.log("refresh", this.$route.name, new Date());
      if(this.$refs._list) {
        this.$refs._list.refresh();
        if(this.sync.enable) {
          this.sync.stop = false; this.pause();
        }
      }
    },
    reset() { this.so = default_opt(); this.refresh(); },
    getRowCount () { return this.so.totalRows || 0; },
    load(ctx = {}) {
      let and = []
      let so = {
        body : { sort : [{ name : "id", op : "desc" }], or : [], and : and  },
        offset : (this.so.currentPage-1 || 0) * this.so.perPage, limit: this.so.perPage, // 10 은 나중에 변수 처리해야함.
      }
      if(ctx.sortBy) { so.body.sort = [ { name : ctx.sortBy, op : !ctx.sortDesc && 'desc' } ]; }
      if(this.user) { so.body.and.push({ name : 'user_id', value : this.user.id, op : '=' }) }
      if( this.so.sv && (this.so.sv || '').trim()) { so.body.and.push(this.set_op(this.so.sk, this.so.sv, so)) }
      if(this.hide_del) { so.body.and.push({ name : 'is_del', value : false, op : '=' }) }

      if(this.so.adv && this.so.opt) {
        var k = Object.keys(this.so.opt)
        for (let i = 0; i < k.length; i++) {
          if(k[i] == 'match_type') { continue; }
          let cond = undefined;

          switch (k[i]) {
            case 'created_at_sd':
              if(!this.so.opt[k[i]]) { this.$toastr.w("start Time is require", "faq"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : ">=" }
              break;
            case 'created_at_ed':
              if(!this.so.opt[k[i]]) { this.$toastr.w("end Time is require", "faq"); break; }
              cond = { name : k[i].slice(0, 10), value : moment(this.so.opt[k[i]]).format("YYYY-MM-DD"), op : "<" }
              break;
            case 'type':
              cond = this.set_op(k[i], this.so.opt[k[i]].value ? this.so.opt[k[i]].value : '');
              break;
            default:
              cond = this.set_op(k[i], this.so.opt[k[i]]);
              break;
          }
          if(cond.value == '%%' || cond.value === '') { continue; }
          if(this.so.opt['match_type'] == "and") { so.body.and.push(cond) }
          else { so.body.or.push(cond) }
        }
      }
      if(this.type) { so.body.and.push(this.set_op('type', this.type.value)); }
      return board.listFaq(so).then(rs => { this.so.totalRows = rs.total; return rs.body; }).catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    goDetail: function(item) { this.$router.push(`faq/${item.id}`); },
    summary() {
      let and = [];
      let id = undefined;
      if(this.user) { id = this.user.id; and.push({ name : 'user_id', value : id, op : '='}) }
      board.summaryFaq({ body : { and : and, or : [], sort : [] } })
        .then(rs => this.summaryData = rs.body)
        .catch(e => this.$toastr.e(e.data ? e.data.message || e.data.title : e.statusText));
    },
    sv_reset(){
      if(this.so.sv != ''){
        this.so.sv = ''
        return this.so.sv
      }
    }
  },
  created() { console.log('board.faq.vue', 'created'); },
  destroyed() { console.log('board.faq.vue', 'destroyed'); },
  mounted() {
    console.log('board.faq.vue', 'mounted');
    if(this.auto_refresh == true) { this.sync.enable = this.auto_refresh; }
    if(this.user) {
      this.so.sk = 'addr'
      this.so.skt = 'Address'
    }
    setTimeout(this.summary, 1000)
  },
}